// Generated by scripts/build-ui-icons.mjs.
export { Newspaper as default } from "../ui/glyphs-5";
